import { getField, updateField } from 'vuex-map-fields'
import { mail } from '../../../firebase'

export const state = () => ({
  drawer: false,
  alert: {
    model: true,
    text: "Quer testar o Erudio na prática? <a href='/contato' style='color: white; text-decoration: underline'>Faça um teste 100% gratuito!</a>"
  },
  plans: [
    {
      slug: 'basic',
      name: 'Básico',
      enrolls_and_invites: true,
      user_management: true,
      tutors_coauthors: true,
      videos_and_support_content: true,
      third_party_calls: true,
      text_editor: true,
      chat: true,
      pay_credit_card: true,
      pay_boleto: true,
      coupons: true,
      default_certificates: true,
      extracts: true,
      course_categorization: true,
      sales_dashboard: true,
      anti_simultaneous_login: true,
      manage_engagement: true,
      forum: true,
      auto_emails: true,
      social_media_login: true,
      email_support: true,
      video720p: true,
      live: false,
      bulk_import_update: false,
      custom_fields: false,
      video1080p: false,
      custom_certificates: false,
      recurrence: false,
      combos: false,
      video_conference: false,
      satisfaction_survey: false,
      lms: false,
      face_to_face_events: false,
      private_class: false,
      content_trails: false,
      open_api: false,
      unique_class_view: false,
      payment_integration: false,
      gamification: false,
      multi_language: false,
      crypt_videos: false,
      dynamic_watermark: false,
      ss_disabled: false,
      time_restriction: false,
      html_iframe: false
    },
    {
      slug: 'business',
      name: 'Business',
      enrolls_and_invites: true,
      user_management: true,
      tutors_coauthors: true,
      videos_and_support_content: true,
      third_party_calls: true,
      text_editor: true,
      chat: true,
      pay_credit_card: true,
      pay_boleto: true,
      coupons: true,
      default_certificates: true,
      extracts: true,
      course_categorization: true,
      sales_dashboard: true,
      anti_simultaneous_login: true,
      manage_engagement: true,
      forum: true,
      auto_emails: true,
      social_media_login: true,
      email_support: true,
      video720p: true,
      live: true,
      bulk_import_update: true,
      custom_fields: true,
      video1080p: true,
      custom_certificates: true,
      recurrence: true,
      combos: true,
      video_conference: true,
      satisfaction_survey: true,
      lms: true,
      face_to_face_events: true,
      private_class: true,
      content_trails: true,
      open_api: false,
      unique_class_view: false,
      payment_integration: false,
      gamification: false,
      multi_language: false,
      crypt_videos: false,
      dynamic_watermark: false,
      ss_disabled: false,
      time_restriction: false,
      html_iframe: false
    },
    {
      slug: 'pro',
      name: 'Professional',
      enrolls_and_invites: true,
      user_management: true,
      tutors_coauthors: true,
      videos_and_support_content: true,
      third_party_calls: true,
      text_editor: true,
      chat: true,
      pay_credit_card: true,
      pay_boleto: true,
      coupons: true,
      default_certificates: true,
      extracts: true,
      course_categorization: true,
      sales_dashboard: true,
      anti_simultaneous_login: true,
      manage_engagement: true,
      forum: true,
      auto_emails: true,
      social_media_login: true,
      email_support: true,
      video720p: true,
      live: true,
      bulk_import_update: true,
      custom_fields: true,
      video1080p: true,
      custom_certificates: true,
      recurrence: true,
      combos: true,
      video_conference: true,
      satisfaction_survey: true,
      lms: true,
      face_to_face_events: true,
      private_class: true,
      content_trails: true,
      open_api: true,
      unique_class_view: true,
      payment_integration: true,
      gamification: true,
      multi_language: true,
      crypt_videos: true,
      dynamic_watermark: true,
      ss_disabled: true,
      time_restriction: true,
      html_iframe: true
    }
  ],
  advantages: [
    {
      advantage: 'enrolls_and_invites',
      title: 'Matrículas e convites'
    },
    {
      advantage: 'user_management',
      title: 'Gestão de usuários/alunos'
    },
    {
      advantage: 'tutors_coauthors',
      title: 'Tutores e Coautores'
    },
    {
      advantage: 'videos_and_support_content',
      title: 'Vídeos e materiais de apoio'
    },
    {
      advantage: 'third_party_calls',
      title: 'Videochamadas por terceiros'
    },
    {
      advantage: 'text_editor',
      title: 'Editor de texto'
    },
    {
      advantage: 'chat',
      title: 'Chat'
    },
    {
      advantage: 'pay_credit_card',
      title: 'Meios de pagamento - Cartão de crédito'
    },
    {
      advantage: 'pay_boleto',
      title: 'Meios de pagamento - Boleto'
    },
    {
      advantage: 'coupons',
      title: 'Cupons de desconto'
    },
    {
      advantage: 'default_certificates',
      title: 'Certificados (Geral)'
    },
    {
      advantage: 'extracts',
      title: 'Extratos'
    },
    {
      advantage: 'course_categorization',
      title: 'Categorização de cursos'
    },
    {
      advantage: 'sales_dashboard',
      title: 'Dashboard de vendas'
    },
    {
      advantage: 'anti_simultaneous_login',
      title: 'Anti login simultâneo'
    },
    {
      advantage: 'manage_engagement',
      title: 'Gestão de engajamento'
    },
    {
      advantage: 'forum',
      title: 'Fórum'
    },
    {
      advantage: 'auto_emails',
      title: 'E-mails automáticos'
    },
    {
      advantage: 'social_media_login',
      title: 'Login com Redes Sociais e Google'
    },
    {
      advantage: 'email_support',
      title: 'Suporte por email'
    },
    {
      advantage: 'video720p',
      title: 'Qualidade dos vídeos 720p'
    },
    {
      advantage: 'live',
      title: 'Transmissão ao vivo'
    },
    {
      advantage: 'bulk_import_update',
      title: 'Importação/atualização em massa automática'
    },
    {
      advantage: 'custom_fields',
      title: 'Campos personalizados'
    },
    {
      advantage: 'video1080p',
      title: 'Qualidade dos vídeos FULL HD'
    },
    {
      advantage: 'custom_certificates',
      title: 'Certificados (Personalizado)'
    },
    {
      advantage: 'recurrence',
      title: 'Assinaturas/Recorrência'
    },
    {
      advantage: 'combos',
      title: 'Combos'
    },
    {
      advantage: 'video_conference',
      title: 'Videoconferência'
    },
    {
      advantage: 'satisfaction_survey',
      title: 'Pesquisa de satisfação'
    },
    {
      advantage: 'lms',
      title: 'Sala de aula - LMS'
    },
    {
      advantage: 'face_to_face_events',
      title: 'Aula presencial (Eventos presenciais)'
    },
    {
      advantage: 'private_class',
      title: 'Aula privada'
    },
    {
      advantage: 'content_trails',
      title: 'Trilhas de conteúdo'
    },
    {
      advantage: 'open_api',
      title: 'API aberta'
    },
    {
      advantage: 'unique_class_view',
      title: 'Visualização única de vídeo aulas'
    },
    {
      advantage: 'payment_integration',
      title: 'Integração com meios de pagamento'
    },
    {
      advantage: 'gamification',
      title: 'Gamificação'
    },
    {
      advantage: 'multi_language',
      title: 'Multi idiomas'
    },
    {
      advantage: 'crypt_videos',
      title: 'Vídeos criptografados (padrão)'
    },
    {
      advantage: 'dynamic_watermark',
      title: "Marca d'água dinâmica (padrão)"
    },
    {
      advantage: 'ss_disabled',
      title: 'Captura de tela desabilitada em IOS e Android (padrão)'
    },
    {
      advantage: 'time_restriction',
      title: 'Restrição baseada em horário e geolocalização (padrão)'
    },
    {
      advantage: 'html_iframe',
      title: 'HTML e iframe'
    }
  ]
})

export const getters = {
  getField,
  tableAdvantages(state) {
    return state.advantages.map((a) => {
      state.plans.forEach((p) => {
        a[p.slug] = p[a.advantage]
      })
      return a
    })
  }
}

export const actions = {
  async sendForm(_, payload) {
    return mail.add(payload)
  }
}

export const mutations = {
  updateField
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
